/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S3_BodyInputs */

const tr_servis_s3_body = /** @type {(inputs: Servis_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik ücretleri, en az 30 gün önceden kayıtlı e-posta adresinize bildirilmek kaydıyla güncellenebilir. Yeni fiyatı kabul etmemeniz halinde yürürlük tarihinden önce aboneliğinizi feshedebilir ve kalan kullanım hakkınızı tamamlayabilirsiniz.`)
};

const en_servis_s3_body = /** @type {(inputs: Servis_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription fees may be updated provided that they are notified to your registered e-mail address at least 30 days in advance. If you do not accept the new price, you may terminate your subscription before the effective date and use up your remaining right of use.`)
};

const de_servis_s3_body = /** @type {(inputs: Servis_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Abonnementgebühren können aktualisiert werden, sofern dies mindestens 30 Tage im Voraus an Ihre registrierte E-Mail-Adresse mitgeteilt wird. Wenn Sie den neuen Preis nicht akzeptieren, können Sie Ihr Abonnement vor dem Wirksamkeitsdatum kündigen und Ihr verbleibendes Nutzungsrecht aufbrauchen.`)
};

const ru_servis_s3_body = /** @type {(inputs: Servis_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стоимость подписки может быть изменена при условии уведомления на вашу зарегистрированную электронную почту не менее чем за 30 дней. Если вы не принимаете новую цену, вы можете расторгнуть подписку до даты вступления изменения в силу и использовать оставшийся период.`)
};

/**
* | output |
* | --- |
* | "Subscription fees may be updated provided that they are notified to your registered e-mail address at least 30 days in advance. If you do not accept the new ..." |
*
* @param {Servis_S3_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s3_body = /** @type {((inputs?: Servis_S3_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S3_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s3_body(inputs)
	if (locale === "de") return de_servis_s3_body(inputs)
	if (locale === "ru") return ru_servis_s3_body(inputs)
	return tr_servis_s3_body(inputs)
});